import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=13abea6c"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=13abea6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/src/oncheckbuild_FutureGAJDKUpgrade90d6697d/FL2FL3nodefinapp/subbrandtool/client/1.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFooter } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VFooter,VSpacer})
